import { logger } from '@/services/LoggingService';

export function logIntegrityProcessing(
  institutionId: string,
  summary: { total_checks?: number; failures?: number; warnings?: number } | null | undefined,
  autoCleanupPerformed?: boolean
) {
  try {
    logger.info('wealthica2.integrity', 'Processing results', {
      institutionId,
      totalChecks: summary?.total_checks || 0,
      failures: summary?.failures || 0,
      warnings: summary?.warnings || 0,
      autoCleanup: !!autoCleanupPerformed,
      timestamp: new Date().toISOString(),
    });
  } catch {
    // Fallback to console if logger not available at runtime
    // eslint-disable-next-line no-console
    console.info('🔍 INTEGRITY: Processing results', {
      institutionId,
      totalChecks: summary?.total_checks || 0,
      failures: summary?.failures || 0,
      warnings: summary?.warnings || 0,
      autoCleanup: !!autoCleanupPerformed,
    });
  }
}
